import React from "react";
import { withRouter } from "react-router-dom";
import "./DealMemo.scss";
import { withUserContext } from "../../../contexts/UserContext";
import { MDBRow, MDBCol, MDBIcon } from "mdb-react-ui-kit";
import BasicButton from "../../components/SharedComponents/BasicButton/BasicButton";
import BasicLabel from "../../components/SharedComponents/BasicLabel/BasicLabel";
import Accordion from "@material-ui/core/Accordion";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import Typography from "@material-ui/core/Typography";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import TableComponent from "../../components/SharedComponents/Table";
import BasicTextField from "../../components/SharedComponents/BasicTextField/BasicTextField";
import messages from "../../Common/Messages.json";
import { validateAlpVarCharNumOnlyWithSpace,validateEmail,validateAllPhone,formatPhoneNumbers } from '../../Common/Helper'
import { createDealMemoRecords } from './DealMemoConfig'

class RepresentativeInfo extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        representativeDetails:{...this.props.representativeDetails},
        expandedvalue: true
    };
  }

  componentDidMount() {
    if (this.props?.userRef) {
      this.props.userRef.current = {
        getRepresentativeDetails: this.getRepresentativeDetails.bind(this)
      }
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.representativeDetails !== this.props.representativeDetails) {
      this.setState({ representativeDetails: this.props?.representativeDetails });
    }
  }

  getRepresentativeDetails=()=>{
    let repData = {...this.state.representativeDetails}
    return repData
  }

  handleChange = (field, value) => {
    this.setState(
      (prev) => ({
        representativeDetails: { ...prev.representativeDetails, [field]: value },
      }),
      () => this.props.handleRepresentativeChange(this.state.representativeDetails)
    );
  }

  handleAgentFieldChange = (index, field, value) => {
    const agents = [...this.state.representativeDetails.agents];
    agents[index] = { ...agents[index], [field]: value };
    this.setState(
      { representativeDetails: { ...this.state.representativeDetails, agents } },
      () => this.props.handleRepresentativeChange(this.state.representativeDetails)
    );
  }

  handleAddAgent = () => {
    const agents = this.state.representativeDetails.agents;
    const last = agents[agents.length - 1];
    if (!last?.agent?.trim()) return;
    this.setState(
      { representativeDetails: { ...this.state.representativeDetails, agents: [...agents, { ...createDealMemoRecords.representativeDetails.agents[0] }] } },
      () => this.props.handleRepresentativeChange(this.state.representativeDetails)
    );
  }

  handleManagerFieldChange = (index, field, value) => {
    const managers = [...this.state.representativeDetails.managers];
    managers[index] = { ...managers[index], [field]: value };
    this.setState(
      { representativeDetails: { ...this.state.representativeDetails, managers } },
      () => this.props.handleRepresentativeChange(this.state.representativeDetails)
    );
  }

  handleAddManager = () => {
    const managers = this.state.representativeDetails.managers;
    const last = managers[managers.length - 1];
    if (!last?.manager?.trim()) return;
    this.setState(
      { representativeDetails: { ...this.state.representativeDetails, managers: [...managers, { ...createDealMemoRecords.representativeDetails.managers[0] }] } },
      () => this.props.handleRepresentativeChange(this.state.representativeDetails)
    );
  }

  handleRemoveManager = (index) => {
    const managers = this.state.representativeDetails.managers;
    if (managers.length <= 1) return;
    this.setState(
      { representativeDetails: { ...this.state.representativeDetails, managers: managers.filter((_, i) => i !== index) } },
      () => this.props.handleRepresentativeChange(this.state.representativeDetails)
    );
  }

  handleRemoveAgent = (index) => {
    const agents = this.state.representativeDetails.agents;
    if (agents.length <= 1) return;
    this.setState(
      { representativeDetails: { ...this.state.representativeDetails, agents: agents.filter((_, i) => i !== index) } },
      () => this.props.handleRepresentativeChange(this.state.representativeDetails)
    );
  }


  render() {
    const agents = this.state.representativeDetails?.agents || [];
    const lastAgent = agents[agents.length - 1];
    const canAddAgent = !!(lastAgent?.agent?.trim());
    const managers = this.state.representativeDetails?.managers || [];
    const lastManager = managers[managers.length - 1];
    const canAddManager = !!(lastManager?.manager?.trim());

    return (
      <div className="RepresentativeInfoContainer">
        <MDBRow>
          <div className="top accordion-display">
            <Accordion expanded={this.props?.mode !== "view" ? this.state.expandedvalue : !this.state.expandedvalue}>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                onClick={()=>this.setState({expandedvalue: !this.state.expandedvalue})}
              >
                <Typography className="mainlabel-text">Representative Information</Typography>
              </AccordionSummary>
              <AccordionDetails className="borderLabel-color">
               {/* <MDBRow> */}
                 <MDBCol md={6} className="border-right">
                    <MDBRow>
                       <MDBCol md={6}>
                        {this.props?.mode === "view" ? (<div>
                          <BasicLabel text={"Agency"}/>
                          <span className={"subText-font"}>{this.state.representativeDetails?.agency}</span>
                        </div>) : (
                             <BasicTextField 
                                label={"Agency"}
                                value={this.state.representativeDetails?.agency || ""}
                                onChange={(e) => validateAlpVarCharNumOnlyWithSpace(e.target.value) ? this.handleChange('agency', e.target.value.length > 0 ? e.target.value : null) : null}
                            />
                        )}
                       </MDBCol>
                       <MDBCol md={2} />
                       <MDBCol md={3} className="d-flex justify-content-center align-items-center">
                        {this.props?.mode !== "view" && (
                          <BasicButton
                            variant="contained"
                            type="inline"
                            icon={"plus"}
                            text={"Add Agent"}
                            className={"add-agent-btn"}
                            disabled={!canAddAgent}
                            onClick={() => this.handleAddAgent()}
                          />
                        )}
                       </MDBCol>
                    </MDBRow>

                    <div className="agent-block-separator" />

                    {/* Agent blocks — one per agents entry */}
                    {agents.map((agentObj, index) => (
                      <div key={agentObj.agent_id != null ? String(agentObj.agent_id) : `new-${index}`}>
                        {index > 0 && <div className="agent-block-separator" />}
                    <MDBRow>
                    <MDBCol md={4}>
                      {this.props?.mode === "view" ? ( <div>
                        <BasicLabel text={"Agent"}/>
                        <span className={"subText-font"}>{agentObj.agent}</span>
                      </div> ) : (
                             <BasicTextField 
                                label={"Agent"}
                                value={agentObj.agent || ""}
                                onChange={(e) => validateAlpVarCharNumOnlyWithSpace(e.target.value) ? this.handleAgentFieldChange(index, 'agent', e.target.value.length > 0 ? e.target.value : null) : null}
                            />
                    )}
                       </MDBCol>
                       <MDBCol md={4}>
                        {this.props?.mode === "view" ? ( <div>
                          <BasicLabel text={"Email"}/>
                          <span className={"subText-font"}>{agentObj.rep_email}</span>
                        </div> ) : (
                             <BasicTextField 
                                label={"Email"}
                                fieldValid={!validateEmail(agentObj.rep_email) && agentObj.rep_email}
                                inValidInput={messages.invalidInput}
                                value={agentObj.rep_email || ""}
                                onChange={(e) => this.handleAgentFieldChange(index, 'rep_email', e.target.value)}
                              />
                            )}
                          </MDBCol>
                          <MDBCol md={3}>
                            {this.props?.mode === "view" ? (
                              <div>
                                <BasicLabel text={"Office Number"}/>
                                <span className={"subText-font"}>{agentObj.rep_office_number}</span>
                              </div>
                            ) : (
                              <BasicTextField
                                label={"Office Number"}
                                placeholder="(xxx)xxx-xxxx"
                                fieldValid={agentObj.rep_office_number ? !validateAllPhone(agentObj.rep_office_number) : false}
                                inValidInput={"Please enter valid phone"}
                                value={agentObj.rep_office_number || ""}
                                onChange={(e) => {
                                  let v = formatPhoneNumbers(e.target.value);
                                  if (v.length > 18) v = v.slice(0, 18);
                                  this.handleAgentFieldChange(index, 'rep_office_number', v);
                                }}
                              />
                            )}
                       </MDBCol>
                    </MDBRow>
                    <MDBRow>
                    <MDBCol md={4}>
                      {this.props?.mode === "view" ? (<div>
                        <BasicLabel text={"Cell Number"}/>
                        <span className={"subText-font"}>{agentObj.rep_cell_number}</span>
                      </div> ) : (
                             <BasicTextField 
                                label={"Cell Number"}
                                placeholder="(xxx)xxx-xxxx"
                                fieldValid={agentObj.rep_cell_number ? !validateAllPhone(agentObj.rep_cell_number) : false}
                                inValidInput={"Please enter valid phone"}
                                value={agentObj.rep_cell_number || ""}
                                onChange={(e) => {
                                  let v = formatPhoneNumbers(e.target.value);
                                  if (v.length > 18) v = v.slice(0, 18);
                                  this.handleAgentFieldChange(index, 'rep_cell_number', v);
                                }}
                              />
                            )}
                          </MDBCol>
                          <MDBCol md={4}>
                            {this.props?.mode === "view" ? (
                              <div>
                                <BasicLabel text={"Assistant's Cell"}/>
                                <span className={"subText-font"}>{agentObj.rep_asst_cell_number}</span>
                              </div>
                            ) : (
                              <BasicTextField
                                label={"Assistant's Cell"}
                                placeholder="(xxx)xxx-xxxx"
                                fieldValid={agentObj.rep_asst_cell_number ? !validateAllPhone(agentObj.rep_asst_cell_number) : false}
                                inValidInput={"Please enter valid phone"}
                                value={agentObj.rep_asst_cell_number || ""}
                                onChange={(e) => {
                                  let v = formatPhoneNumbers(e.target.value);
                                  if (v.length > 18) v = v.slice(0, 18);
                                  this.handleAgentFieldChange(index, 'rep_asst_cell_number', v);
                                }}
                              />
                            )}
                          </MDBCol>
                          <MDBCol md={4} className="d-flex justify-content-center align-items-center">
                            {this.props?.mode !== "view" && agents.length > 1 && (
                              <BasicButton
                                variant="contained"
                                type="inline"
                                icon={"minus"}
                                text={"Remove Agent"}
                                className={"remove-agent-btn"}
                                onClick={() => this.handleRemoveAgent(index)}
                              />
                            )}
                       </MDBCol>
                    </MDBRow>
                      </div>
                    ))}
                 </MDBCol>
                 <MDBCol md={6}>
                    {/* Row 1 — Management Company + Add Manager button */}
                    <MDBRow>
                       <MDBCol md={6}>
                        {this.props?.mode === "view" ? ( <div>
                          <BasicLabel text={"Management Company"}/>
                          <span className={"subText-font"}>{this.state.representativeDetails?.management_company}</span>
                        </div> ) : (
                             <BasicTextField 
                                label={"Management Company"}
                                value={this.state.representativeDetails?.management_company || ""}
                                onChange={(e) => validateAlpVarCharNumOnlyWithSpace(e.target.value) ? this.handleChange('management_company', e.target.value.length > 0 ? e.target.value : null) : null}
                          />
                        )}
                       </MDBCol>
                       <MDBCol md={2} />
                       <MDBCol md={4} className="d-flex justify-content-center align-items-center">
                        {this.props?.mode !== "view" && (
                          <BasicButton
                            variant="contained"
                            type="inline"
                            icon={"plus"}
                            text={"Add Manager"}
                            className={"add-agent-btn"}
                            disabled={!canAddManager}
                            onClick={() => this.handleAddManager()}
                          />
                        )}
                       </MDBCol>
                    </MDBRow>

                    <div className="agent-block-separator" />

                    {/* Manager blocks — one per managers entry */}
                    {managers.map((managerObj, index) => (
                      <div key={managerObj.manager_id != null ? String(managerObj.manager_id) : `new-mgr-${index}`}>
                        {index > 0 && <div className="agent-block-separator" />}
                        <MDBRow>
                          <MDBCol md={4}>
                            {this.props?.mode === "view" ? (
                              <div>
                                <BasicLabel text={"Manager"}/>
                                <span className={"subText-font"}>{managerObj.manager}</span>
                              </div>
                            ) : (
                              <BasicTextField
                                label={"Manager"}
                                value={managerObj.manager || ""}
                                onChange={(e) => validateAlpVarCharNumOnlyWithSpace(e.target.value) ? this.handleManagerFieldChange(index, 'manager', e.target.value.length > 0 ? e.target.value : null) : null}
                              />
                            )}
                          </MDBCol>
                          <MDBCol md={4}>
                            {this.props?.mode === "view" ? (
                              <div>
                                <BasicLabel text={"Email"}/>
                                <span className={"subText-font"}>{managerObj.mc_email}</span>
                              </div>
                            ) : (
                              <BasicTextField
                                label={"Email"}
                                fieldValid={!validateEmail(managerObj.mc_email) && managerObj.mc_email}
                                inValidInput={messages.invalidInput}
                                value={managerObj.mc_email || ""}
                                onChange={(e) => this.handleManagerFieldChange(index, 'mc_email', e.target.value)}
                              />
                            )}
                          </MDBCol>
                          <MDBCol md={3}>
                            {this.props?.mode === "view" ? (
                              <div>
                                <BasicLabel text={"Office Number"}/>
                                <span className={"subText-font"}>{managerObj.mc_office_number}</span>
                              </div>
                            ) : (
                              <BasicTextField
                                label={"Office Number"}
                                placeholder="(xxx)xxx-xxxx"
                                fieldValid={managerObj.mc_office_number ? !validateAllPhone(managerObj.mc_office_number) : false}
                                inValidInput={"Please enter valid phone"}
                                value={managerObj.mc_office_number || ""}
                                onChange={(e) => {
                                  let v = formatPhoneNumbers(e.target.value);
                                  if (v.length > 18) v = v.slice(0, 18);
                                  this.handleManagerFieldChange(index, 'mc_office_number', v);
                                }}
                              />
                            )}
                          </MDBCol>
                        </MDBRow>
                        <MDBRow>
                          <MDBCol md={4}>
                            {this.props?.mode === "view" ? (
                              <div>
                                <BasicLabel text={"Cell Number"}/>
                                <span className={"subText-font"}>{managerObj.mc_cell_number}</span>
                              </div>
                            ) : (
                              <BasicTextField
                                label={"Cell Number"}
                                placeholder="(xxx)xxx-xxxx"
                                fieldValid={managerObj.mc_cell_number ? !validateAllPhone(managerObj.mc_cell_number) : false}
                                inValidInput={"Please enter valid phone"}
                                value={managerObj.mc_cell_number || ""}
                                onChange={(e) => {
                                  let v = formatPhoneNumbers(e.target.value);
                                  if (v.length > 18) v = v.slice(0, 18);
                                  this.handleManagerFieldChange(index, 'mc_cell_number', v);
                                }}
                              />
                            )}
                          </MDBCol>
                          <MDBCol md={4}>
                            {this.props?.mode === "view" ? (
                              <div>
                                <BasicLabel text={"Assistant's Cell"}/>
                                <span className={"subText-font"}>{managerObj.mc_asst_cell_number}</span>
                              </div>
                            ) : (
                              <BasicTextField
                                label={"Assistant's Cell"}
                                placeholder="(xxx)xxx-xxxx"
                                fieldValid={managerObj.mc_asst_cell_number ? !validateAllPhone(managerObj.mc_asst_cell_number) : false}
                                inValidInput={"Please enter valid phone"}
                                value={managerObj.mc_asst_cell_number || ""}
                                onChange={(e) => {
                                  let v = formatPhoneNumbers(e.target.value);
                                  if (v.length > 18) v = v.slice(0, 18);
                                  this.handleManagerFieldChange(index, 'mc_asst_cell_number', v);
                                }}
                              />
                            )}
                          </MDBCol>
                          <MDBCol md={4} className="d-flex justify-content-center align-items-center">
                            {this.props?.mode !== "view" && managers.length > 1 && (
                              <BasicButton
                                variant="contained"
                                type="inline"
                                icon={"minus"}
                                text={"Remove Manager"}
                                className={"remove-agent-btn"}
                                onClick={() => this.handleRemoveManager(index)}
                              />
                            )}
                          </MDBCol>
                        </MDBRow>
                      </div>
                    ))}
                 </MDBCol>
               {/* </MDBRow> */}
              </AccordionDetails>
            </Accordion>
          </div>
        </MDBRow>
      </div>
    );
  }
}
export default withUserContext(RepresentativeInfo);